import BasicContent from './BasicContent';
import GwpCalculatorContainer from '../../Insulation/FoamularNgx/GwpCalculatorContainer';

const NGXCalculator = ({ copy }) => (
  <>
    <BasicContent content={copy} />
    <GwpCalculatorContainer />
  </>
);

export default NGXCalculator;
